import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import store from '@/my/store'
import i18n from '@/i18n'
import nl from 'vuetify/lib/locale/nl'
import en from 'vuetify/lib/locale/en'
import '@/my/sass/overrides.sass'

Vue.use(Vuetify)

var d = false
if (store.state.darkMode !== null) {
    d = store.state.darkMode
} else {
    store.commit('SET_DARK_MODE', d)
}

const theme = {
  primary: '#F3B42A',
  secondary: '#32333B',
  accent: '#F3B42A',
  info: '#26282E',
}

export default new Vuetify({
  lang: {
    locales: { nl, en },
    current: i18n.locale,
    // t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
    dark: d,
  },
})

/* -- Logo --
Geel: #F3B42A / rgb(243, 180, 42)
Grijs: #32333B / rgb(50, 51, 59)
Wit: #FFFFFF / rgb(255, 255, 255)
-- Website --
Geel: F4B500 / rgb(244, 181, 0)
Lichtgrijs: #32333B / rgb(50, 51, 59)
Donkergrijs: #26282E / rgb(38, 40, 46)
*/
